export const getS3FileName = (key) =>
  String(key || '')
    .split('/')
    .pop();

export const isPdfS3Key = (key) => getS3FileName(key).toLowerCase().endsWith('.pdf');

export const sortS3KeysPdfFirst = (keys = []) => {
  return [...keys].sort((a, b) => {
    const aIsPdf = isPdfS3Key(a);
    const bIsPdf = isPdfS3Key(b);

    if (aIsPdf && !bIsPdf) return -1;
    if (!aIsPdf && bIsPdf) return 1;

    return getS3FileName(a).localeCompare(getS3FileName(b));
  });
};
